import { SchemaService } from "@/shared/services/SchemaService";
import { TableSchema } from "../models/TableSchema";
import { PlottingService } from "@/components/Plotting/services/PlottingService";


export class TablesSchemaService extends SchemaService<TableSchema> {

    static readonly injectableKey = 'TablesSchemaService';

    get injectableKey() {
        return (this.constructor as typeof TablesSchemaService).injectableKey;
    }

    public cdnContentPath: string = "tables/tables_schemas";

    public getInternalSchemas(): Array<TableSchema> {

        const internalRuleSchemas = [
            {
                "type": `${PlottingService.CUSTOM_PLOT_TYPE}`,
                "display_name": "Unknown Table",
                "description": "Add unknown Table",
                "category": "Custom",
                "is_visible": false,
                "fields": [
                    {
                        "name": "value",
                        "display_name": "Json",
                        "field_type": "json",
                        "required": true,
                        "description": "Json Value"
                    }
                ],
                "examples": [
                    {
                        "type": "json"
                    }
                ]
            },
        ] as Array<TableSchema>;

        return internalRuleSchemas;

    }

}